const AustrianWaltzLead = {
    name: "Austrian Waltz",
    bpm: 180,
    signature: "6/8",
    introMeasures: 8,
    pattern: [

    ]
};

export default AustrianWaltzLead;